import { isNil, omitBy } from 'lodash';

export const getObjectWithoutNilValues = (object: object) => {
  return omitBy(object, isNil);
};
